import { UIElement } from "../ui-element.js";
//#region src/ui/volume-indicator/value.ts
var VolumeIndicatorValueElement = class extends UIElement {
	static {
		this.tagName = "media-volume-indicator-value";
	}
};
//#endregion
export { VolumeIndicatorValueElement };
